export enum ChargeCreditCardStatus {
  REQUESTING = 'REQUESTING',
  REQUESTED = 'REQUESTED',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  IDLE = 'IDLE',
}
